function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box, IconButton, Link, Stack, styled, Typography, useTheme } from '@mui/material';
import { SocialLoginType, useIsClientFlexTrack } from '@procom-labs/common';
import FacebookSvg from '@common-assets/svg/social/facebook.svg';
import GoogleSvg from '@common-assets/svg/social/google.svg';
import LinkedInSvg from '@common-assets/svg/social/linkedin.svg';
var SocialButton = styled(Link, {})(function() {
    return {
        cursor: 'pointer',
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };
});
export var SocialMediaButtonGroup = function(param) {
    var storageUrl = param.storageUrl, handleClick = param.handleClick, _param_socialLoginTypes = param.socialLoginTypes, socialLoginTypes = _param_socialLoginTypes === void 0 ? [
        SocialLoginType.Google,
        SocialLoginType.Facebook,
        SocialLoginType.Linkedin
    ] : _param_socialLoginTypes;
    var theme = useTheme();
    var isClientFlexTrack = useIsClientFlexTrack();
    var filteredSocialLoginTypes = isClientFlexTrack ? socialLoginTypes.filter(function(type) {
        return type !== SocialLoginType.Linkedin;
    }) : socialLoginTypes;
    var socialList = useMemo(function() {
        return [
            {
                name: SocialLoginType.Google,
                svg: /*#__PURE__*/ _jsx("svg", {
                    "data-src": GoogleSvg,
                    "data-loading": "lazy",
                    style: {
                        fill: theme.palette.primary.main
                    }
                })
            },
            {
                name: SocialLoginType.Facebook,
                svg: /*#__PURE__*/ _jsx("svg", {
                    "data-src": FacebookSvg,
                    "data-loading": "lazy",
                    style: {
                        fill: theme.palette.primary.main
                    }
                })
            },
            {
                name: SocialLoginType.Linkedin,
                svg: /*#__PURE__*/ _jsx("svg", {
                    "data-src": LinkedInSvg,
                    "data-loading": "lazy",
                    style: {
                        fill: theme.palette.primary.main
                    }
                })
            }
        ];
    }, [
        theme.palette.primary.main
    ]);
    return /*#__PURE__*/ _jsx(Stack, {
        direction: "row",
        spacing: 2.5,
        justifyContent: "center",
        children: filteredSocialLoginTypes.map(function(socialLoginType) {
            return /*#__PURE__*/ _jsx(SocialButton, {
                onClick: function() {
                    return handleClick(socialLoginType);
                },
                sx: _object_spread({}, socialLoginType === SocialLoginType.Microsoft && {
                    flex: 1,
                    textDecoration: 'unset'
                }),
                children: socialLoginType !== SocialLoginType.Microsoft ? socialList.map(function(socialListItem) {
                    if (socialListItem.name === socialLoginType) {
                        return /*#__PURE__*/ _jsx(IconButton, {
                            children: socialListItem.svg
                        }, socialListItem.name);
                    }
                    return null;
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            component: "img",
                            alt: socialLoginType,
                            src: "".concat(storageUrl, "/procom-portal-assets/icons/").concat(socialLoginType.toLocaleLowerCase(), ".png")
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            component: "p",
                            variant: "subtitle1",
                            ml: 1,
                            children: "Microsoft 365"
                        })
                    ]
                })
            }, socialLoginType);
        })
    });
};
